import { render } from "./EditOrderPointsModal.vue?vue&type=template&id=a20d0bde"
import script from "./EditOrderPointsModal.vue?vue&type=script&lang=js"
export * from "./EditOrderPointsModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__